export default __webpack_public_path__ + "static/media/probit.7bda21e4.svg";